"use strict";

var _regeneratorRuntime = require("/home/runner/work/hakka.finance/hakka.finance/node_modules/@babel/runtime/regenerator");

var _asyncToGenerator = require("/home/runner/work/hakka.finance/hakka.finance/node_modules/@babel/runtime/helpers/asyncToGenerator");

var _classCallCheck = require("/home/runner/work/hakka.finance/hakka.finance/node_modules/@babel/runtime/helpers/classCallCheck");

var _createClass = require("/home/runner/work/hakka.finance/hakka.finance/node_modules/@babel/runtime/helpers/createClass");

var _inherits = require("/home/runner/work/hakka.finance/hakka.finance/node_modules/@babel/runtime/helpers/inherits");

var _possibleConstructorReturn = require("/home/runner/work/hakka.finance/hakka.finance/node_modules/@babel/runtime/helpers/possibleConstructorReturn");

var _getPrototypeOf = require("/home/runner/work/hakka.finance/hakka.finance/node_modules/@babel/runtime/helpers/getPrototypeOf");

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.SubscribeBlockTracker = void 0;

var json_rpc_random_id_1 = __importDefault(require("json-rpc-random-id"));

var BaseBlockTracker_1 = require("./BaseBlockTracker");

var createRandomId = (0, json_rpc_random_id_1.default)();

var SubscribeBlockTracker = /*#__PURE__*/function (_BaseBlockTracker_1$B) {
  _inherits(SubscribeBlockTracker, _BaseBlockTracker_1$B);

  var _super = _createSuper(SubscribeBlockTracker);

  function SubscribeBlockTracker() {
    var _this;

    var opts = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

    _classCallCheck(this, SubscribeBlockTracker);

    // parse + validate args
    if (!opts.provider) {
      throw new Error('SubscribeBlockTracker - no provider specified.');
    } // BaseBlockTracker constructor


    _this = _super.call(this, opts); // config

    _this._provider = opts.provider;
    _this._subscriptionId = null;
    return _this;
  }

  _createClass(SubscribeBlockTracker, [{
    key: "checkForLatestBlock",
    value: function () {
      var _checkForLatestBlock = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
        return _regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _context.next = 2;
                return this.getLatestBlock();

              case 2:
                return _context.abrupt("return", _context.sent);

              case 3:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, this);
      }));

      function checkForLatestBlock() {
        return _checkForLatestBlock.apply(this, arguments);
      }

      return checkForLatestBlock;
    }()
  }, {
    key: "_start",
    value: function () {
      var _start2 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee2() {
        var blockNumber;
        return _regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                if (!(this._subscriptionId === undefined || this._subscriptionId === null)) {
                  _context2.next = 15;
                  break;
                }

                _context2.prev = 1;
                _context2.next = 4;
                return this._call('eth_blockNumber');

              case 4:
                blockNumber = _context2.sent;
                _context2.next = 7;
                return this._call('eth_subscribe', 'newHeads');

              case 7:
                this._subscriptionId = _context2.sent;

                this._provider.on('data', this._handleSubData.bind(this));

                this._newPotentialLatest(blockNumber);

                _context2.next = 15;
                break;

              case 12:
                _context2.prev = 12;
                _context2.t0 = _context2["catch"](1);
                this.emit('error', _context2.t0);

              case 15:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2, this, [[1, 12]]);
      }));

      function _start() {
        return _start2.apply(this, arguments);
      }

      return _start;
    }()
  }, {
    key: "_end",
    value: function () {
      var _end2 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee3() {
        return _regeneratorRuntime.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                if (!(this._subscriptionId !== null && this._subscriptionId !== undefined)) {
                  _context3.next = 10;
                  break;
                }

                _context3.prev = 1;
                _context3.next = 4;
                return this._call('eth_unsubscribe', this._subscriptionId);

              case 4:
                this._subscriptionId = null;
                _context3.next = 10;
                break;

              case 7:
                _context3.prev = 7;
                _context3.t0 = _context3["catch"](1);
                this.emit('error', _context3.t0);

              case 10:
              case "end":
                return _context3.stop();
            }
          }
        }, _callee3, this, [[1, 7]]);
      }));

      function _end() {
        return _end2.apply(this, arguments);
      }

      return _end;
    }()
  }, {
    key: "_call",
    value: function _call(method) {
      var _this2 = this;

      for (var _len = arguments.length, params = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
        params[_key - 1] = arguments[_key];
      }

      return new Promise(function (resolve, reject) {
        _this2._provider.sendAsync({
          id: createRandomId(),
          method: method,
          params: params,
          jsonrpc: '2.0'
        }, function (err, res) {
          if (err) {
            reject(err);
          } else {
            resolve(res.result);
          }
        });
      });
    }
  }, {
    key: "_handleSubData",
    value: function _handleSubData(_, response) {
      var _a;

      if (response.method === 'eth_subscription' && ((_a = response.params) === null || _a === void 0 ? void 0 : _a.subscription) === this._subscriptionId) {
        this._newPotentialLatest(response.params.result.number);
      }
    }
  }]);

  return SubscribeBlockTracker;
}(BaseBlockTracker_1.BaseBlockTracker);

exports.SubscribeBlockTracker = SubscribeBlockTracker;